const initialState = {
	findLabels: null,
    isLabelsLoading: true,
    isNewLabelsLoading: false,
    labelStateUpdating: null,
    labelsPageNumber: 1,
    popupLabelsPageNumber: 1,
    labelsPageSize: 100,
	getSelectedContactsGroup: null,
	selectSeveralContactsGroups: [],
	getEnteredSearchValue: "",
    getFilteredStatus: null,
    gmailAddOnShareContact: false,
	changeContactsGroupStatus: [],
    checkComponentRendering:true,
	hasSharedLabels: false,
	hasCollaboratorsPending: false,
    allLabelsFetched: false,
    selectOneLabelFromPopup: null,
	displayLabelSearch: false,
    isContactLabelCollapsed: [],
    isContactLabelHidden: [],
    labelDropdown: "",
	waitingContactsGroupsLevel: false
};

const contactsGroupItemReducer = ( state = initialState, action ) => {
    switch (action.type){

        case 'GMAIL_ADD_ON_SHARE_CONTACT':
            state = {
                ...state,
                gmailAddOnShareContact: true,
            };
            break;

        case "FIND_LABELS":
		    state = {
			    ...state,
			    findLabels: action.payload
		    };
		    break;
        case "FIND_NEXT_LABELS":
            state = {
                ...state,
                findLabels: {
                    ...state.findLabels,
                    contactsGroups: [
                        ...state.findLabels.contactsGroups,
                        ...action.payload.contactsGroups
                    ]
                }
            };
            break;
        case "REFRESH_LABELS":
            state = {
                ...state,
                findLabels: {
                    ...state.findLabels,
                    contactsGroups: [...state.findLabels.contactsGroups, ...action.payload]
                }
            };
            break;
	    case "FIND_LABELS_BY_TYPE":
		    state = {
			    ...state,
			    findLabels: action.payload
		    };
		    break;
        case "REFRESH_LABELS_BY_TYPE":
            state = {
                ...state,
                findLabels: {
                    ...state.findLabels,
                    contactsGroups: [...state.findLabels.contactsGroups, ...action.payload]
                }
            };
            break;
        case "IS_LABELS_LOADING":
            state = {
                ...state,
                isLabelsLoading: action.payload
            };
            break;
        case "IS_NEW_LABELS_LOADING":
            state = {
                ...state,
                isNewLabelsLoading: action.payload
            };
            break;
        case "CHECK_COMPONENT_RENDERING":
                state = {
                    ...state,
                    checkComponentRendering:action.payload
                }
                break;

        case "LABEL_STATE_UPDATING":
            state = {
                ...state,
                labelStateUpdating: action.payload
            };
            break;
	    case "LOAD_NEW_LABELS":
		    state = {
			    ...state,
			    findLabels: {
			    	...state.findLabels,
				    contactsGroups: [...state.findLabels.contactsGroups, ...action.payload]
			    }
		    };
		    break;
        case "LABELS_PAGE_NUMBER":
            state = {
                ...state,
                labelsPageNumber: action.payload
            };
            break;
        case "POPUP_LABELS_PAGE_NUMBER":
            state = {
                ...state,
                popupLabelsPageNumber: action.payload
            };
            break;
	    case "LABELS_PAGE_SIZE":
		    state = {
			    ...state,
                labelsPageSize: action.payload
		    };
		    break;
	    case "GET_SELECTED_CONTACTS_GROUP":
		    state = {
			    ...state,
			    getSelectedContactsGroup: action.payload
		    };
		    break;
	    case "SELECT_SEVERAL_CONTACTS_GROUPS":
		    state = {
			    ...state,
			    selectSeveralContactsGroups: action.payload
		    };
		    break;
	    case "GET_ENTERED_SEARCH_VALUE":
		    state = {
			    ...state,
			    getEnteredSearchValue: action.payload
		    };
		    break;
	    case "GET_FILTERED_STATUS":
		    state = {
			    ...state,
			    getFilteredStatus: action.payload
		    };
		    break;
	    case "CHANGE_CONTACTS_GROUP_STATUS":
		    state = {
			    ...state,
			    changeContactsGroupStatus: action.payload
		    };
            break;
	    case "HAS_SHARED_LABELS":
		    state = {
			    ...state,
			    hasSharedLabels: action.payload
		    };
		    break;
	    case "HAS_COLLABORATORS_PENDING":
		    state = {
			    ...state,
			    hasCollaboratorsPending: action.payload
		    };
		    break;
        case "ALL_LABELS_FETCHED":
            state = {
                ...state,
                allLabelsFetched: action.payload
            };
            break;
        case "SELECT_ONE_LABEL_FROM_POPUP":
            state = {
                ...state,
                selectOneLabelFromPopup: action.payload
            };
            break;
	    case "DISPLAY_LABEL_SEARCH":
		    state = {
			    ...state,
			    displayLabelSearch: action.payload
		    };
		    break;
        case "IS_CONTACT_LABEL_COLLAPSED":
            state = {
                ...state,
                isContactLabelCollapsed: action.payload
            };
            break;
        case "IS_CONTACT_LABEL_HIDDEN":
            state = {
                ...state,
                isContactLabelHidden: action.payload
            };
            break;
        case "LABEL_DROPDOWN":
            state = {
                ...state,
                labelDropdown: action.payload
            };
            break;
	    case "WAITING_CONTACTS_GROUPS_LEVEL":
		    state = {
			    ...state,
			    waitingContactsGroupsLevel: action.payload
		    };
		    break;
	    default :
		    break;
    }
    return state;
};

export default contactsGroupItemReducer;
